export interface Bonus {
  badge: string
  title: string
  subtitle: string
  description: string
  value: string
  image: string
}

export const bonuses: Bonus[] = [
  {
    badge: 'Bonus #1',
    title: 'Oclusion Red Flags™',
    subtitle: '50 Clinical Signals Worth a Closer Look',
    description:
      'A visual library of clinical signals organized into practical categories, designed to help you recognize which findings deserve additional attention during your evaluation.',
    value: '$47',
    image: 'https://cdn.magicpatterns.com/uploads/8p4UJXcqQjFvds336TctJ8/BONUS_1_OCLUSION-EN.png',
  },
  {
    badge: 'Bonus #2',
    title: 'VDO Master Map™',
    subtitle: 'A Visual Framework for Organizing Your VDO Assessment',
    description:
      'A dedicated reference map bringing key variables and questions together in one place.',
    value: '$37',
    image: 'https://cdn.magicpatterns.com/uploads/ro4n1ZUAkYots9PZJHmBsc/BONUS_2_OCLUSION-EN.png',
  },
  {
    badge: 'Bonus #3',
    title: 'Complex Case Lab™',
    subtitle: '10 Cases to Train Your Clinical Reasoning',
    description:
      'Work through complex case scenarios and compare your reasoning with the proposed analysis.',
    value: '$47',
    image: 'https://cdn.magicpatterns.com/uploads/sGiTvVcvg7VPnfQJsus1Uw/BONUS_3_OCLUSION-EN.png',
  },
  {
    badge: 'Bonus #4',
    title: 'Clinical Quick Cards™',
    subtitle: '30 Rapid-Reference Clinical Cards',
    description:
      'Each card follows a simple framework: Signal → Question → Variable → Assessment → Next Step.',
    value: '$37',
    image: 'https://cdn.magicpatterns.com/uploads/kqZWTNNKs7nUf21H1wgdyR/BONUS_4_OCLUSION-EN.png',
  },
  {
    badge: 'Bonus #5',
    title: 'Pre-Treatment Audit™',
    subtitle: 'Your Final Review Before Moving Forward',
    description:
      'A structured checklist for reviewing critical elements before proceeding with treatment.',
    value: '$29',
    image: 'https://cdn.magicpatterns.com/uploads/pYTU22rMcZxKnQjDmcJeHJ/BONUS_5_OCLUSION-EN.png',
  },
]
